import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { TemplatesQueries } from 'src/app/shared/types/get-query';
import { ExportChannel } from '../../models/new/export-channel';
import { ExportChannelMapper } from '../../services/export-channel-mapper';

@Component({
	standalone: false,
	selector: 'bt-company-third-parties-applications',
	templateUrl: './company-third-parties-applications.component.html',
	styleUrls: ['./company-third-parties-applications.component.scss']
})
export class CompanyThirdPartiesApplicationsComponent implements OnInit {
	exportChannels: ExportChannel[] = [];

	constructor(
		private graphQLService: GraphQLService,
		private exportChannelMapper: ExportChannelMapper
	) {}

	ngOnInit(): void {
		this.getExportChannels();
	}

	getExportChannels(): void {
		this.graphQLService
			.getData<any>(TemplatesQueries.GET_EXPORT_CHANNELS)
			.pipe(
				map((res: any) =>
					(res.data.exportChannels?.nodes || []).map((node: any) => this.exportChannelMapper.toExportChannel(node))
				)
			)
			.subscribe({
				next: (channels: ExportChannel[]) => {
					this.exportChannels = channels;
				}
			});
	}
}
